import Vue from 'vue'
import Router from 'vue-router'

import waybillManagement from './modules/waybillManagement'
import endWaybill from './modules/endWaybill'
import myProfile from './modules/myProfile'
import financialManagement from './modules/financialManagement'
import freightInquiry from './modules/freightInquiry'
import abroadWaybill from './modules/abroadWaybill'
import std from './modules/std'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    hidden: true,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: 'dashboard', icon: 'dashboard' }
      }
    ]
  },
  waybillManagement,
  std,
  abroadWaybill,
  // smallParcelWaybill,
  endWaybill,

  financialManagement,
  {
    path: '/waybillManagement/sendWaybillDetail/:id/:token',
    hidden: true,
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "line-chart" */ '@/views/waybillManagement/sendWaybillDetail.vue'
      ),
    name: 'sendWaybillDetail',
    meta: {
      title: 'sendWaybillDetail',
      noCache: true
    }
  },
  myProfile,

  // 亚马逊
  {
    path: '/seaair/amazon',
    component: Layout,
    // redirect: '/systemInformation/systemInformation',
    redirect: 'noredirect',
    meta: {
      title: 'amazon',
      icon: 'order'
    },
    hidden: true,
    children: [
      {
        path: 'inbound/shipment/create',
        component: () =>
          import(/* webpackChunkName: "guide" */ '@/views/amazon/inbound.vue'),
        name: 'Inbound',
        meta: {
          title: 'inbound',
          noCache: true
        }
      },
      {
        path: 'inbound/shipment/list',
        component: () =>
          import(/* webpackChunkName: "guide" */ '@/views/amazon/planList.vue'),
        name: 'Planlist',
        meta: {
          title: 'planlist',
          noCache: true
        }
      },
      {
        path: 'createOrder',
        hidden: true,
        component: () =>
          import(/* webpackChunkName: "guide" */ '@/views/amazon/createOrder.vue'),
        name: 'CreateOrder',
        // hidden: true,
        meta: {
          title: 'amazonCreateOrder',
          noCache: true
        }
      }

    ]
  },

  {
    path: '/systemHelp',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      title: 'systemHelp',
      icon: 'help-line'
    },
    children: [
      {
        path: 'contactUs',
        component: () =>
          import(/* webpackChunkName: "error-page-401" */ '@/views/systemHelp/contactUs.vue'),
        name: 'ContactUs',
        /*meta: {
          title: 'contactUs',
          noCache: true
        },*/
      },
      {
        path: 'quickOrderGuidance',
        component: () =>
          import(
            /* webpackChunkName: "error-page-404" */ '@/views/systemHelp/quickOrderGuidance.vue'
          ),
        name: 'QuickOrderGuidance',
        meta: {
          title: 'quickOrderGuidance',
          noCache: true
        }
      }
    ]
  },

  {
    path: '/systemInformation',
    component: Layout,
    // redirect: '/systemInformation/systemInformation',
    redirect: 'noredirect',
    meta: {
      title: 'systemInformation',
      icon: 'msg-line'
    },
    children: [
      {
        path: 'systemInformation',
        component: () =>
          import(/* webpackChunkName: "guide" */ '@/views/systemInformation/systemInformation.vue'),
        name: 'SystemInformation',
        meta: {
          title: 'systemInformation',
          noCache: true
        }
        // meta: {
        //   title: 'systemInformation',
        //   icon: 'msg-line',
        //   noCache: true
        // }
      }

    ]
  },

  {
    path: '/quotationList',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      title: 'quotationList',
      icon: 'Inquiry-line'
    },
    children: [
      {
        path: 'quotationList',
        component: () =>
          import(/* webpackChunkName: "guide" */ '@/views/quotationList/index.vue'),
        name: 'quotationList',
        meta: {
          title: 'quotationList',
          noCache: true
        }
        // meta: {
        //   title: 'systemInformation',
        //   icon: 'msg-line',
        //   noCache: true
        // }
      } ,{
        path: 'quotedPrice/detail',
        name: 'quotedPriceDeatil',
        component: () => import("@/views/quotationList/detail"),
      },

    ]
  },{

    path: '/billException/:billId/:billName/:billAmount/:dateTime',
    component:  () => import('@/views/billException/index'),
    name: 'billException',
    meta: {
      title: 'billException'
    },
      hidden:true
  },
  // {
  //   path: '/icons',
  //   component: Layout,
  //   redirect: '/icons',
  //   children: [
  //     {
  //       path: 'systemInformation',
  //       component: () => import(/* webpackChunkName: "guide" */ '@/views/icons/index.vue'),
  //       name: 'icons',
  //       meta: {
  //         title: 'icons',
  //         icon: 'guide',
  //         noCache: true
  //       }
  //     }
  //   ]
  // }
]

/**
 * asyncRoutes
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  freightInquiry,
  { path: '*', redirect: '/dashboard', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
